/* N1 COMUM (n1-comum, 03/11/2026): scripts que antes ficavam escritos dentro de toda pagina. Carregado com defer:
   roda depois que a pagina e lida e antes do DOMContentLoaded. Cada bloco continua isolado na sua funcao. */

/* ===== de layout/theme.liquid: function ativarArrasto(el) ===== */
(function () {
        function ativarArrasto(el) {
          if (el.dataset.n1Arrasto === '1') return;
          el.dataset.n1Arrasto = '1';

          var baixo = false, moveu = false, xInicial = 0, scrollInicial = 0;

          el.addEventListener('pointerdown', function (e) {
            if (e.pointerType !== 'mouse' || e.button !== 0) return;
            baixo = true;
            moveu = false;
            xInicial = e.clientX;
            scrollInicial = el.scrollLeft;
          });

          el.addEventListener('pointermove', function (e) {
            if (!baixo) return;
            var dx = e.clientX - xInicial;
            if (!moveu && Math.abs(dx) < 5) return;
            if (!moveu) {
              moveu = true;
              el.classList.add('n1-arrastando');
              if (el.setPointerCapture) { try { el.setPointerCapture(e.pointerId); } catch (err) {} }
            }
            el.scrollLeft = scrollInicial - dx;
            e.preventDefault();
          });

          function soltar() {
            baixo = false;
            if (moveu) {
              setTimeout(function () { el.classList.remove('n1-arrastando'); }, 0);
            }
          }

          el.addEventListener('pointerup', soltar);
          el.addEventListener('pointercancel', soltar);
          el.addEventListener('pointerleave', soltar);

          el.addEventListener('click', function (e) {
            if (moveu) { e.preventDefault(); e.stopPropagation(); }
          }, true);

          el.addEventListener('dragstart', function (e) { e.preventDefault(); });
        }

        function iniciar() {
          document.querySelectorAll('.n1-product-carousel').forEach(ativarArrasto);
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', iniciar);
        } else {
          iniciar();
        }

        document.addEventListener('shopify:section:load', iniciar);
      })();

/* ===== de layout/theme.liquid: var PALAVRAS = ['cor', 'color' ===== */
(function () {
        var PALAVRAS = ['cor', 'color', 'cores'];

        function esconderRotuloPorTexto(janela) {
          var tudo = janela.querySelectorAll('span, label, legend, p, div, strong, b');

          for (var i = 0; i < tudo.length; i++) {
            var el = tudo[i];
            if (el.getAttribute('data-n1-texto') === '1') continue;
            if (el.children.length !== 0) continue;

            var texto = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
            texto = texto.replace(/[:：]+$/, '').trim();

            if (PALAVRAS.indexOf(texto) === -1) continue;

            el.setAttribute('data-n1-texto', '1');
            el.style.display = 'none';

            /* Se o rotulo mora sozinho dentro de um invólucro, esconde o invólucro tambem,
               senao sobra a altura dele fazendo um buraco no lugar. */
            var pai = el.parentElement;
            if (pai && pai !== janela && pai.children.length === 1) {
              pai.style.display = 'none';
            }
          }
        }

        function limpar() {
          var janelas = document.querySelectorAll('.quick-buy-modal');

          for (var j = 0; j < janelas.length; j++) {
            var janela = janelas[j];

            /* Primeiro caminho: rotulos e listas na ordem do documento. Cada rotulo pertence
               a primeira lista que vem depois dele, sem depender de parentesco. */
            var nos = janela.querySelectorAll('[class*="swatch-label"], .swatch-view');
            var rotulo = null;

            for (var i = 0; i < nos.length; i++) {
              var no = nos[i];
              var ehLista = no.classList && no.classList.contains('swatch-view');

              if (!ehLista) {
                rotulo = no;
                continue;
              }

              if (no.getAttribute('data-n1-visto') !== '1') {
                no.setAttribute('data-n1-visto', '1');

                if (no.children.length === 1) {
                  no.style.display = 'none';
                  if (rotulo) rotulo.style.display = 'none';
                }
              }

              rotulo = null;
            }

            /* Segundo caminho: pelo proprio texto. Cor na loja sempre tem um valor unico,
               porque cada cor e um produto separado, entao esse rotulo nunca faz falta. */
            esconderRotuloPorTexto(janela);
          }
        }

        var relogio;
        function agendar() {
          clearTimeout(relogio);
          relogio = setTimeout(limpar, 60);
        }

        function iniciar() {
          limpar();
          if (!window.MutationObserver) return;
          new MutationObserver(agendar).observe(document.body, { childList: true, subtree: true });
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', iniciar);
        } else {
          iniciar();
        }
      })();

/* ===== de layout/theme.liquid: var agendado = false;

        ===== */
(function () {
        var agendado = false;

        function alinhar() {
          agendado = false;
          var listas = document.querySelectorAll('.product-list');

          Array.prototype.forEach.call(listas, function (lista) {
            var itens = [];

            Array.prototype.forEach.call(lista.querySelectorAll('product-card'), function (card) {
              if (card.offsetParent === null) return;
              var info = card.querySelector('.product-card__info');
              var marco = card.querySelector('.n1-preco') || card.querySelector('.n1-card-titulo');
              if (!info || !marco) return;
              info.style.removeProperty('padding-top');
              itens.push({ card: card, info: info, marco: marco });
            });
            if (itens.length < 2) return;

            var fileiras = {};

            /* Parcelamento e tamanhos: solta, mede e aplica a maior altura da fileira. */
            ['.n1-card-parcela', '.n1-card-tamanhos'].forEach(function (seletor) {
              var partes = [];
              itens.forEach(function (item) {
                var el = item.card.querySelector(seletor);
                if (!el) return;
                el.style.removeProperty('min-height');
                partes.push({ card: item.card, el: el });
              });
              var grupos = {};
              partes.forEach(function (parte) {
                var chave = Math.round(parte.card.getBoundingClientRect().top + window.pageYOffset);
                parte.altura = Math.ceil(parte.el.getBoundingClientRect().height);
                (grupos[chave] = grupos[chave] || []).push(parte);
              });
              Object.keys(grupos).forEach(function (chave) {
                var maior = 0;
                grupos[chave].forEach(function (parte) {
                  if (parte.altura > maior) maior = parte.altura;
                });
                grupos[chave].forEach(function (parte) {
                  if (parte.altura < maior) parte.el.style.setProperty('min-height', maior + 'px', 'important');
                });
              });
            });

            itens.forEach(function (item) {
              var caixaCard = item.card.getBoundingClientRect();
              item.base = parseFloat(getComputedStyle(item.info).paddingTop) || 0;
              item.desce = item.marco.getBoundingClientRect().top - caixaCard.top;
              var chave = Math.round(caixaCard.top + window.pageYOffset);
              (fileiras[chave] = fileiras[chave] || []).push(item);
            });

            Object.keys(fileiras).forEach(function (chave) {
              var grupo = fileiras[chave];
              var maior = 0;
              grupo.forEach(function (item) {
                if (item.desce > maior) maior = item.desce;
              });
              grupo.forEach(function (item) {
                var falta = maior - item.desce;
                if (falta > 0.5) {
                  item.info.style.setProperty('padding-top', (item.base + falta) + 'px', 'important');
                }
              });
            });
          });
        }

        function agendar() {
          if (agendado) return;
          agendado = true;
          (window.requestAnimationFrame || setTimeout)(alinhar);
        }

        var tempoResize = null;
        window.addEventListener('resize', function () {
          clearTimeout(tempoResize);
          tempoResize = setTimeout(agendar, 120);
        });
        window.addEventListener('load', agendar);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(agendar);

        function iniciar() {
          agendar();
          if (!window.MutationObserver) return;
          var espera = null;
          new MutationObserver(function (mudancas) {
            var mexeuEmCard = mudancas.some(function (m) {
              var alvo = m.target;
              return alvo && alvo.nodeType === 1 && alvo.closest && alvo.closest('.product-list');
            });
            if (!mexeuEmCard) return;
            clearTimeout(espera);
            espera = setTimeout(agendar, 100);
          }).observe(document.body, { childList: true, subtree: true });
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', iniciar);
        } else {
          iniciar();
        }
      })();

/* ===== de snippets/n1-menu.liquid (escala) ===== */
/* n1-menu-escala: ajusta o menu para caber na tela sem rolar, em qualquer celular */
      (function () {
        if (window.n1MenuEscala) return;
        window.n1MenuEscala = true;
        function cabe() {
          var menu = document.querySelector('.header-sidebar');
          if (!menu) return;
          var caixa = menu.querySelector('.header-sidebar__main-panel .header-sidebar__scroller');
          if (!caixa || !caixa.clientHeight) return;
          var k = 1;
          menu.style.setProperty('--n1mn-k', '1');
          var voltas = 0;
          while (caixa.scrollHeight > caixa.clientHeight + 1 && k > 0.5 && voltas < 30) {
            k = Math.max(0.5, k * Math.min(0.97, caixa.clientHeight / caixa.scrollHeight + 0.02));
            menu.style.setProperty('--n1mn-k', k.toFixed(3));
            voltas++;
          }
        }
        var espera = null;
        function agenda() {
          if (espera) cancelAnimationFrame(espera);
          espera = requestAnimationFrame(function () { espera = requestAnimationFrame(cabe); });
        }
        function liga() {
          var menu = document.querySelector('.header-sidebar');
          if (!menu) return;
          new MutationObserver(function () {
            if (menu.hasAttribute('open')) { agenda(); setTimeout(cabe, 350); }
          }).observe(menu, { attributes: true, attributeFilter: ['open'] });
          window.addEventListener('resize', agenda);
          window.addEventListener('orientationchange', function () { setTimeout(cabe, 300); });
          if (window.visualViewport) window.visualViewport.addEventListener('resize', agenda);
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(agenda);
          agenda();
        }
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga);
        else liga();
      })();

/* ===== de snippets/n1-carrinho.liquid ===== */
/* n1-carrinho: copia o cupom (delegado) e, em n1-carrinho-frete-acima, leva o quadro de frete do app
     (injetado depois do Compre junto) para cima dele, logo abaixo dos produtos. Refaz a cada atualizacao da gaveta. */
  (function () {
    if (window.n1CarrinhoIniciado) return;
    window.n1CarrinhoIniciado = true;
    function reordena() {
      var gaveta = document.getElementById('cart-drawer');
      if (!gaveta) return;
      var comp = gaveta.querySelector('.cart-drawer__complementary-products');
      if (!comp || !comp.parentElement) return;
      var el = comp.nextElementSibling, mover = [];
      while (el) {
        var tag = el.tagName;
        if (!el.hasAttribute('slot') && tag !== 'SCRIPT' && tag !== 'STYLE' && tag !== 'TEMPLATE' && !el.classList.contains('cart-drawer__footer')) mover.push(el);
        el = el.nextElementSibling;
      }
      mover.forEach(function (m) { comp.parentElement.insertBefore(m, comp); });
      /* n1-carrinho-frete-bonito: marca o que o app injetou (entre os produtos e o Compre junto) e arruma textos */
      var itens = gaveta.querySelector('.cart-drawer__items');
      var no = itens ? itens.nextElementSibling : null;
      while (no && no !== comp) {
        if (!no.hasAttribute('slot') && no.tagName !== 'SCRIPT' && no.tagName !== 'STYLE') {
          no.classList.add('n1c-frete');
          var andar = document.createTreeWalker(no, NodeFilter.SHOW_TEXT, null), t;
          while ((t = andar.nextNode())) {
            if (t.nodeValue.indexOf('Brazil') > -1) t.nodeValue = t.nodeValue.replace(/Brazil/g, 'Brasil');
            if (/^[\s\u00a0]*[-\u2013\u2022][\s\u00a0]*$/.test(t.nodeValue)) t.nodeValue = '';
          }
          Array.prototype.forEach.call(no.querySelectorAll('*'), function (x) {
            if (x.children.length === 0 && /^\s*-?\s*Frete estimados?\s*$/i.test(x.textContent)) x.style.display = 'none';
            if (x.tagName === 'OPTION' && x.textContent.trim() === 'Brazil') x.textContent = 'Brasil';
          });
          if (/^\s*-?\s*Frete estimados?\s*$/i.test(no.textContent)) no.style.display = 'none';
          arrumaFrete(no);
        }
        no = no.nextElementSibling;
      }
    }
    /* n1-carrinho-frete-compacto: esconde os totais repetidos do app e recolhe o formulario de CEP atras de um link */
    function sobeAte(el, raiz, ok) {
      while (el && el.parentElement && el.parentElement !== raiz && ok(el.parentElement)) el = el.parentElement;
      return el;
    }
    function arrumaFrete(no) {
      var folhas = no.querySelectorAll('*');
      Array.prototype.forEach.call(folhas, function (x) {
        if (x.matches('input, select, option, button, label')) return;
        if (/^\s*Frete para /i.test(x.textContent) && x.textContent.length < 120 && !Array.prototype.some.call(x.children, function (c) { return /^\s*Frete para /i.test(c.textContent); })) x.classList.add('n1c-destino');
      });
      /* n1-carrinho-frete-blocos: cada opcao de frete vira um bloco, seja qual for a estrutura que o app gerar */
      Array.prototype.forEach.call(no.querySelectorAll('input[type="radio"]'), function (rd) {
        var op = sobeAte(rd, no, function (pai) { return pai.querySelectorAll('input[type="radio"]').length === 1; });
        if (!op || op === no) return;
        op.classList.add('n1c-opcao');
        var prox = op.nextElementSibling;
        if (prox && !prox.querySelector('input') && /receba|entrega|dias? [uú]teis/i.test(prox.textContent) && prox.textContent.length < 80) {
          op.classList.add('n1c-opcao--com-data'); prox.classList.add('n1c-opcao-data');
        }
      });
      var campoCep = no.querySelector('input[type="text"], input[type="tel"], input[type="number"], input:not([type])');
      var cepCampo = campoCep ? campoCep.value.replace(/\D/g, '') : '';
      /* n1-carrinho-cep-calculado: o titulo segue o ultimo CEP CALCULADO (nao o que esta sendo digitado) */
      var cepCalc = window.n1CepCalculado;
      if (!cepCalc) { try { cepCalc = sessionStorage.getItem('n1CepCalculado'); } catch (e) {} }
      var local = cepCalc ? localDoCep(cepCalc) : null;
      if (local) {
        /* o titulo pode vir em pedacos (<span>): troca o menor elemento que contem a frase inteira */
        var regras = [[/^\s*Frete para /i, 'Frete para ' + local], [/^\s*N[aã]o est[aá] enviando para /i, 'Não está enviando para ' + local + '?']];
        Array.prototype.forEach.call(folhas, function (x) {
          if (x.matches('input, select, option, button, label')) return;
          var t = x.textContent;
          regras.forEach(function (r) {
            if (!r[0].test(t) || t.trim() === r[1]) return;
            var filhoTambem = Array.prototype.some.call(x.children, function (c) { return r[0].test(c.textContent); });
            if (!filhoTambem && t.length < 120) x.textContent = r[1];
          });
        });
      }
      Array.prototype.forEach.call(folhas, function (x) {
        if (x.children.length === 0 && x.textContent.trim() === 'Subtotal' && !x.closest('.n1c-totais')) {
          var bloco = sobeAte(x, no, function (pai) {
            return !pai.querySelector('select, input, button, label') && pai.textContent.length < 200;
          });
          if (bloco && bloco !== no) bloco.classList.add('n1c-totais');
        }
      });
      var sel = no.querySelector('select, input[type="text"], input[type="tel"], input:not([type])');
      if (!sel) return;
      var form = sel.closest('form');
      if (!form || !no.contains(form) || form.querySelector('input[type="radio"]')) {
        form = sobeAte(sel, no, function (pai) { return !pai.querySelector('input[type="radio"]'); });
      }
      if (!form || form === no) return;
      form.classList.add('n1c-cep');
      /* n1-carrinho-cep-primeiro: o campo de CEP vai para o topo do formulario, antes de pais e estado */
      var cep = form.querySelector('input[type="text"], input[type="tel"], input[type="number"], input:not([type])');
      if (cep) {
        var bloco = cep;
        while (bloco.parentElement && bloco.parentElement !== form) bloco = bloco.parentElement;
        var primeiroCampo = form.querySelector('select');
        if (primeiroCampo) {
          var alvo = primeiroCampo;
          while (alvo.parentElement && alvo.parentElement !== form) alvo = alvo.parentElement;
          if (bloco.parentElement === form && alvo.parentElement === form && bloco !== alvo && (alvo.compareDocumentPosition(bloco) & Node.DOCUMENT_POSITION_FOLLOWING)) form.insertBefore(bloco, alvo);
        }
        /* n1-carrinho-cep-atual: o nome do local sempre segue o CEP que esta no campo agora */
        var atual = cep.value.replace(/\D/g, '');
        if (atual.length === 8 && form._n1Cep !== atual) preencheEstado(form, atual);
        if (!cep.getAttribute('placeholder')) cep.setAttribute('placeholder', 'Digite seu CEP');
        var btCalc = form.querySelector('button:not(.n1c-cep-abre), input[type="submit"], input[type="button"]');
        if (btCalc && !/CALCULANDO/.test(btCalc.value || btCalc.textContent)) {
          if (btCalc.tagName === 'INPUT') { if (btCalc.value !== 'CALCULAR') btCalc.value = 'CALCULAR'; }
          else if (btCalc.textContent.trim() !== 'CALCULAR') btCalc.textContent = 'CALCULAR';
        }
        cep.setAttribute('inputmode', 'numeric');
        /* n1-carrinho-cep-auto: esconde pais e estado e preenche os dois pelo CEP (ViaCEP) */
        Array.prototype.forEach.call(form.querySelectorAll('select'), function (sel) {
          var b2 = sel;
          while (b2.parentElement && b2.parentElement !== form) b2 = b2.parentElement;
          b2.classList.add('n1c-oculto');
        });
        if (!cep.dataset.n1Auto) {
          cep.dataset.n1Auto = '1';
          cep.addEventListener('input', function () {
            var d = cep.value.replace(/\D/g, '').slice(0, 8);
            var fmt = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
            if (cep.value !== fmt) cep.value = fmt;
            if (d.length === 8) preencheEstado(form, d);
          });
          var inicial = cep.value.replace(/\D/g, '');
          if (inicial.length === 8) preencheEstado(form, inicial);
        }
      }
      Array.prototype.forEach.call(folhas, function (x) {
        if (x.children.length === 0 && /n[aã]o est[aá] enviando/i.test(x.textContent)) { var pg = sobeAte(x, no, function (pai) { return !pai.contains(form) && !pai.querySelector('input[type="radio"]'); }); pg.classList.add('n1c-cep'); pg.classList.add('n1c-pergunta'); }
      });
      if (!no.querySelector('.n1c-cep-abre')) {
        var bt = document.createElement('button');
        bt.type = 'button'; bt.className = 'n1c-cep-abre';
        bt.textContent = window.n1CepAberto ? 'Fechar' : 'Calcular para outro CEP';
        bt.addEventListener('click', function () {
          window.n1CepAberto = !window.n1CepAberto;
          no.classList.toggle('n1c-cep-aberto', window.n1CepAberto);
          bt.textContent = window.n1CepAberto ? 'Fechar' : 'Calcular para outro CEP';
        });
        var primeiro = no.querySelector('.n1c-cep');
        primeiro.parentElement.insertBefore(bt, primeiro);
      }
      no.classList.toggle('n1c-cep-aberto', !!window.n1CepAberto);
      /* n1-carrinho-link-cep: o texto do link sempre acompanha o estado (aberto: Fechar | fechado: Calcular para outro CEP) */
      var linkCep = no.querySelector('.n1c-cep-abre');
      if (linkCep) {
        var rotulo = window.n1CepAberto ? 'Fechar' : 'Calcular para outro CEP';
        if (linkCep.textContent !== rotulo) linkCep.textContent = rotulo;
      }
    }
    var UFS = { AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás',
      MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Pará', PB: 'Paraíba', PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí',
      RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo', SE: 'Sergipe', TO: 'Tocantins' };
    function sem(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(); }
    function escolhe(sel, testes) {
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        if (testes.some(function (t) { return sem(o.value) === sem(t) || sem(o.textContent) === sem(t); })) {
          if (sel.value !== o.value) { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          return true;
        }
      }
      return false;
    }
    /* n1-carrinho-cep-faixa: estado pelo CEP sem internet (faixas oficiais dos Correios) */
    var FAIXAS = [[1000,19999,'SP'],[20000,28999,'RJ'],[29000,29999,'ES'],[30000,39999,'MG'],[40000,48999,'BA'],[49000,49999,'SE'],
      [50000,56999,'PE'],[57000,57999,'AL'],[58000,58999,'PB'],[59000,59999,'RN'],[60000,63999,'CE'],[64000,64999,'PI'],[65000,65999,'MA'],
      [66000,68899,'PA'],[68900,68999,'AP'],[69000,69299,'AM'],[69300,69399,'RR'],[69400,69899,'AM'],[69900,69999,'AC'],[70000,72799,'DF'],
      [72800,72999,'GO'],[73000,73699,'DF'],[73700,76799,'GO'],[76800,76999,'RO'],[77000,77999,'TO'],[78000,78899,'MT'],[78900,78999,'RO'],[79000,79999,'MS'],
      [80000,87999,'PR'],[88000,89999,'SC'],[90000,99999,'RS']];
    function ufDoCep(d) {
      var n = parseInt(String(d).slice(0, 5), 10);
      for (var i = 0; i < FAIXAS.length; i++) if (n >= FAIXAS[i][0] && n <= FAIXAS[i][1]) return FAIXAS[i][2];
      return null;
    }
    function localDoCep(d) {
      var uf = ufDoCep(d);
      if (!uf) return null;
      if (window.n1CidadeCep === d && window.n1Cidade) return window.n1Cidade + ', ' + uf;
      return UFS[uf];
    }
    function marcaEstado(form, uf) {
      return new Promise(function (ok) {
        var tentativas = 0;
        (function tenta() {
          var todos = form.querySelectorAll('select');
          if (todos[0]) escolhe(todos[0], ['Brazil', 'Brasil', 'BR']);
          var est = todos[todos.length - 1];
          var achou = est && est !== todos[0] && escolhe(est, [uf, UFS[uf] || '', 'BR-' + uf]);
          if (achou) { try { console.info('[N1 frete] CEP ' + form._n1Cep + ' = ' + (UFS[uf] || uf) + ' | estado marcado: ' + est.value); } catch (e) {} ok(true); return; }
          if (++tentativas > 12) { try { console.warn('[N1 frete] estado ' + uf + ' nao encontrado na lista do app'); } catch (e) {} ok(false); return; }
          setTimeout(tenta, 150);
        })();
      });
    }
    function preencheEstado(form, digitos) {
      var uf = ufDoCep(digitos);
      if (!uf) return Promise.resolve(false);
      if (form._n1Cep === digitos && form._n1Promessa) return form._n1Promessa;
      form._n1Cep = digitos;
      form._n1Promessa = marcaEstado(form, uf);
      /* cidade: opcional, so melhora o titulo quando o ViaCEP responde */
      if (window.n1CidadeCep !== digitos) {
        try {
          fetch('https://viacep.com.br/ws/' + digitos + '/json/').then(function (r) { return r.json(); }).then(function (j) {
            if (j && !j.erro && j.localidade) { window.n1Cidade = j.localidade; window.n1CidadeCep = digitos; setTimeout(reordena, 0); }
          }).catch(function () {});
        } catch (e) {}
      }
      setTimeout(reordena, 0);
      return form._n1Promessa;
    }
    /* n1-carrinho-cep-espera: segura o clique em "Obter valor do frete" ate o estado do CEP estar marcado */
    document.addEventListener('click', function (e) {
      var bt = e.target.closest && e.target.closest('form.n1c-cep button, form.n1c-cep input[type="button"], form.n1c-cep input[type="submit"], .n1c-cep button, .n1c-cep input[type="button"], .n1c-cep input[type="submit"]');
      if (!bt || bt.classList.contains('n1c-cep-abre')) return;
      var form = bt.closest('.n1c-cep');
      if (!form) return;
      if (form.dataset.n1Liberado === '1') { form.dataset.n1Liberado = ''; return; }
      var cep = form.querySelector('input[type="text"], input[type="tel"], input[type="number"], input:not([type])');
      var d = cep ? cep.value.replace(/\D/g, '') : '';
      if (d.length !== 8) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var texto = bt.tagName === 'INPUT' ? bt.value : bt.textContent;
      if (bt.tagName === 'INPUT') bt.value = 'CALCULANDO...'; else bt.textContent = 'CALCULANDO...';
      /* n1-carrinho-fallback: nunca trava o calculo. Se algo falhar ou demorar mais de 3 s, o app calcula como sempre calculou */
      var liberou = false;
      function libera(marcou) {
        if (liberou) return;
        liberou = true;
        try {
          if (bt.tagName === 'INPUT') bt.value = texto; else bt.textContent = texto;
          if (marcou === true) {
            window.n1CepCalculado = d;
            try { sessionStorage.setItem('n1CepCalculado', d); } catch (e) {}
          } else {
            window.n1CepCalculado = null;
            try { sessionStorage.removeItem('n1CepCalculado'); } catch (e) {}
          }
          window.n1CepAberto = false;
        } catch (e) {}
        form.dataset.n1Liberado = '1';
        bt.click();
        setTimeout(reordena, 0);
      }
      setTimeout(function () { libera(false); }, 3000);
      try { preencheEstado(form, d).then(libera, function () { libera(false); }); } catch (err) { libera(false); }
    }, true);
    var agendado = false;
    new MutationObserver(function () {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(function () { agendado = false; reordena(); });
    }).observe(document.body, { childList: true, subtree: true });
    reordena();
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-n1cr-copiar]');
      if (!b) return;
      var cod = b.getAttribute('data-n1cr-copiar');
      function ok() { b.textContent = 'COPIADO'; setTimeout(function () { b.textContent = 'COPIAR ' + cod; }, 2000); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(cod).then(ok, ok); else ok();
    });
  })();

/* ===== de snippets/n1-carrinho-frete.liquid ===== */
/* n1f-quadro: liga todos os quadros [data-n1f] (o carrinho e redesenhado a cada mudanca) */
  (function () {
    if (window.n1FreteIniciado) return;
    window.n1FreteIniciado = true;

    var UFS = { AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás',
      MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Pará', PB: 'Paraíba', PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí',
      RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo', SE: 'Sergipe', TO: 'Tocantins' };
    var FAIXAS = [[1000,19999,'SP'],[20000,28999,'RJ'],[29000,29999,'ES'],[30000,39999,'MG'],[40000,48999,'BA'],[49000,49999,'SE'],
      [50000,56999,'PE'],[57000,57999,'AL'],[58000,58999,'PB'],[59000,59999,'RN'],[60000,63999,'CE'],[64000,64999,'PI'],[65000,65999,'MA'],
      [66000,68899,'PA'],[68900,68999,'AP'],[69000,69299,'AM'],[69300,69399,'RR'],[69400,69899,'AM'],[69900,69999,'AC'],[70000,72799,'DF'],
      [72800,72999,'GO'],[73000,73699,'DF'],[73700,76799,'GO'],[76800,76999,'RO'],[77000,77999,'TO'],[78000,78899,'MT'],[78900,78999,'RO'],[79000,79999,'MS'],
      [80000,87999,'PR'],[88000,89999,'SC'],[90000,99999,'RS']];
    function ufDoCep(d) {
      var n = parseInt(String(d).slice(0, 5), 10);
      for (var i = 0; i < FAIXAS.length; i++) if (n >= FAIXAS[i][0] && n <= FAIXAS[i][1]) return FAIXAS[i][2];
      return null;
    }
    function ler(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } }
    function grava(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
    function soDigitos(v) { return String(v || '').replace(/\D/g, '').slice(0, 8); }
    function fmtCep(d) { return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d; }
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function moeda(v) {
      var n = Number(v);
      if (!isFinite(n)) return '';
      if (n === 0) return 'Grátis';
      try { return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); } catch (e) { return 'R$ ' + n.toFixed(2).replace('.', ','); }
    }
    function dataBR(s) {
      var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(s || ''));
      return m ? m[3] + '/' + m[2] + '/' + m[1] : '';
    }
    function prazo(r) {
      var d = (r.delivery_days || []).filter(function (x) { return typeof x === 'number'; });
      if (!d.length) return '';
      var a = Math.min.apply(null, d), b = Math.max.apply(null, d);
      if (a === b) return a + (a === 1 ? ' dia' : ' dias');
      return a + ' a ' + b + ' dias';
    }
    function quando(r) {
      var rg = r.delivery_range || [];
      var ini = dataBR(rg[0]), fim = dataBR(rg[rg.length - 1] || r.delivery_date);
      if (!fim) fim = dataBR(r.delivery_date);
      if (ini && fim && ini !== fim) return 'Receba entre ' + ini + ' e ' + fim;
      return fim ? 'Receba até ' + fim : '';
    }

    function desenha(box, res) {
      var el = box.querySelector('.n1f-resultado'), abre = box.querySelector('.n1f-abre'), form = box.querySelector('.n1f-form');
      var erro = box.querySelector('.n1f-erro'), nota = box.querySelector('.n1f-nota'), campo = box.querySelector('.n1f-cep');
      erro.hidden = true;
      if (!res) {
        el.hidden = true; el.innerHTML = ''; abre.hidden = true; form.hidden = false;
        nota.textContent = 'Informe seu CEP para ver o prazo e o valor da entrega.';
        return;
      }
      var local = res.cidade ? res.cidade + ', ' + res.uf : (UFS[res.uf] || res.uf);
      var html = '<p class="n1f-destino"><span>Frete para ' + esc(local) + '<small>CEP ' + esc(fmtCep(res.cep)) + '</small></span></p>';
      res.rates.forEach(function (r) {
        var p = prazo(r), q = quando(r);
        html += '<div class="n1f-opcao"><div class="n1f-linha"><span class="n1f-nome">' + esc(r.nome) + (p ? ' <span>(' + esc(p) + ')</span>' : '') +
          '</span><span class="n1f-preco">' + esc(moeda(r.preco)) + '</span></div>' + (q ? '<span class="n1f-data">' + esc(q) + '</span>' : '') + '</div>';
      });
      el.innerHTML = html; el.hidden = false; abre.hidden = false;
      var aberto = box.classList.contains('is-aberto');
      form.hidden = !aberto;
      abre.textContent = aberto ? 'Fechar' : 'Calcular para outro CEP';
      nota.textContent = 'Valores estimados para o CEP informado. A forma de entrega é escolhida no checkout.';
      if (campo && document.activeElement !== campo) campo.value = fmtCep(res.cep);
    }
    function mostraErro(box, msg) {
      var erro = box.querySelector('.n1f-erro');
      erro.textContent = msg; erro.hidden = false;
      box.querySelector('.n1f-form').hidden = false;
      if (!box.querySelector('.n1f-resultado').hidden) { box.classList.add('is-aberto'); box.querySelector('.n1f-abre').textContent = 'Fechar'; }
    }
    function carregando(box, sim) {
      var bt = box.querySelector('.n1f-calc');
      bt.disabled = sim;
      bt.textContent = sim ? 'Calculando...' : 'Calcular';
    }

    /* n1f-api-nativa: GET /cart/shipping_rates.json; se a Shopify responder "ainda calculando" (202), usa prepare + async */
    function pede(url, qs) {
      return fetch(url + '?' + qs, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) {
        return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) {} return { status: r.status, ok: r.ok, j: j }; });
      });
    }
    function espera(url, qs) {
      var base = url.replace(/shipping_rates\.json$/, '');
      return fetch(base + 'prepare_shipping_rates.json?' + qs, { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .catch(function () {})
        .then(function () {
          var n = 0;
          return new Promise(function (ok) {
            (function tenta() {
              pede(base + 'async_shipping_rates.json', qs).then(function (res) {
                if (res.ok && res.j && res.j.shipping_rates) return ok(res);
                if (++n >= 10) return ok(res);
                setTimeout(tenta, 1000);
              }, function () { if (++n >= 10) ok({ ok: false, status: 0, j: null }); else setTimeout(tenta, 1000); });
            })();
          });
        });
    }
    var vez = 0;
    function calcula(box, d, forcar) {
      var uf = ufDoCep(d);
      if (d.length !== 8 || !uf) { mostraErro(box, 'CEP inválido. Confira os 8 números.'); return; }
      var sig = box.getAttribute('data-n1f-sig');
      var salvo = ler('n1FreteRes');
      if (!forcar && salvo && salvo.cep === d && salvo.sig === sig && salvo.rates) {
        box.classList.remove('is-aberto'); desenha(box, salvo); return;
      }
      var minha = ++vez;
      carregando(box, true);
      var url = box.getAttribute('data-n1f-url');
      var qs = 'shipping_address%5Bzip%5D=' + encodeURIComponent(fmtCep(d)) + '&shipping_address%5Bcountry%5D=Brazil&shipping_address%5Bprovince%5D=' + encodeURIComponent(UFS[uf]);
      var cidade = salvo && salvo.cep === d ? salvo.cidade : '';
      pede(url, qs).then(function (res) {
        if (res.status === 202 || (res.ok && (!res.j || !res.j.shipping_rates))) return espera(url, qs);
        return res;
      }).then(function (res) {
        if (minha !== vez) return;
        carregando(box, false);
        if (!res.ok) {
          var zipErro = res.j && (res.j.zip || res.j.error || res.j.base);
          mostraErro(box, zipErro ? 'Não encontramos esse CEP. Confira os números.' : 'Não foi possível calcular agora. Tente de novo.');
          try { console.warn('[N1 frete] resposta ' + res.status, res.j); } catch (e) {}
          return;
        }
        var rates = (res.j.shipping_rates || []).map(function (r) {
          return { nome: r.presentment_name || r.name, preco: r.price, delivery_days: r.delivery_days, delivery_range: r.delivery_range, delivery_date: r.delivery_date };
        }).sort(function (a, b) { return Number(a.preco) - Number(b.preco); });
        if (!rates.length) { mostraErro(box, 'Não há entrega disponível para esse CEP.'); return; }
        var dados = { cep: d, uf: uf, cidade: cidade, sig: sig, rates: rates };
        grava('n1FreteRes', dados);
        grava('n1FreteCep', d);
        Array.prototype.forEach.call(document.querySelectorAll('[data-n1f]'), function (b) { b.classList.remove('is-aberto'); desenha(b, dados); });
        try { console.info('[N1 frete] CEP ' + d + ' (' + uf + '): ' + rates.length + ' opção(ões)'); } catch (e) {}
        if (!cidade) buscaCidade(d);
      }, function () {
        if (minha !== vez) return;
        carregando(box, false);
        mostraErro(box, 'Não foi possível calcular agora. Tente de novo.');
      });
    }
    /* cidade: opcional, so melhora o titulo quando o ViaCEP responde */
    function buscaCidade(d) {
      try {
        fetch('https://viacep.com.br/ws/' + d + '/json/').then(function (r) { return r.json(); }).then(function (j) {
          var salvo = ler('n1FreteRes');
          if (!j || j.erro || !j.localidade || !salvo || salvo.cep !== d) return;
          salvo.cidade = j.localidade; grava('n1FreteRes', salvo);
          Array.prototype.forEach.call(document.querySelectorAll('[data-n1f]'), function (b) { desenha(b, salvo); });
        }).catch(function () {});
      } catch (e) {}
    }

    /* n1f-recalcula: quadro novo (carrinho redesenhado) abre com o ultimo CEP; se o carrinho mudou, recalcula */
    function liga() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-n1f]:not([data-n1f-pronto])'), function (box) {
        box.setAttribute('data-n1f-pronto', '1');
        var cep = ler('n1FreteCep');
        if (cep && String(cep).length === 8) {
          box.querySelector('.n1f-cep').value = fmtCep(String(cep));
          calcula(box, String(cep), false);
        } else desenha(box, null);
      });
    }
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('.n1f-form');
      if (!form) return;
      e.preventDefault();
      var box = form.closest('[data-n1f]');
      calcula(box, soDigitos(form.querySelector('.n1f-cep').value), true);
    });
    document.addEventListener('input', function (e) {
      if (!e.target.classList || !e.target.classList.contains('n1f-cep')) return;
      var d = soDigitos(e.target.value), f = fmtCep(d);
      if (e.target.value !== f) e.target.value = f;
      var box = e.target.closest('[data-n1f]');
      if (box) box.querySelector('.n1f-erro').hidden = true;
    });
    document.addEventListener('click', function (e) {
      var bt = e.target.closest && e.target.closest('.n1f-abre');
      if (!bt) return;
      var box = bt.closest('[data-n1f]');
      var aberto = !box.classList.contains('is-aberto');
      box.classList.toggle('is-aberto', aberto);
      box.querySelector('.n1f-form').hidden = !aberto;
      box.querySelector('.n1f-erro').hidden = true;
      bt.textContent = aberto ? 'Fechar' : 'Calcular para outro CEP';
      if (aberto) {
        var campo = box.querySelector('.n1f-cep');
        campo.value = '';
        campo.focus();
      }
    });
    var agendado = false;
    new MutationObserver(function () {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(function () { agendado = false; liga(); });
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
    liga();
  })();

/* ===== n1-janela-segura (03/11/2026) ===== */
/* A janela de tamanhos (quick-buy-modal do tema) baixa a pagina inteira do produto antes de abrir. Quando a Shopify
   responde 429 (muitos pedidos seguidos, comum com o app de etiquetas de desconto buscando cada produto da pagina),
   o tema quebra em silencio e o botao ADICIONAR AO CARRINHO nao faz nada. Aqui: tenta de novo depois de 1,2 s e, se
   falhar outra vez, leva a pessoa para a pagina do produto. Nunca fica um botao morto. */
(function () {
  if (!window.customElements || !customElements.whenDefined) return;
  customElements.whenDefined('quick-buy-modal').then(function () {
    var C = customElements.get('quick-buy-modal');
    if (!C || C.prototype.__n1Segura) return;
    var original = C.prototype.show;
    C.prototype.__n1Segura = true;
    C.prototype.show = function () {
      var janela = this, args = arguments;
      function fim() { document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true })); }
      return Promise.resolve().then(function () { return original.apply(janela, args); }).catch(function () {
        fim();
        return new Promise(function (ok) { setTimeout(ok, 1200); }).then(function () {
          return original.apply(janela, args);
        }).catch(function () {
          fim();
          var h = janela.getAttribute('handle');
          if (h) window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + h;
        });
      });
    };
  });
})();
